import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { parseLocalizedPathname } from "@plaatplan/i18n";
import { useLocale } from "./useLocale.js";

export function LocaleRouteSync() {
  const location = useLocation();
  const { preferences, syncLocaleFromRoute } = useLocale();

  useEffect(() => {
    const { locale } = parseLocalizedPathname(location.pathname);
    if (locale !== preferences.locale) {
      syncLocaleFromRoute(locale);
    }
  }, [location.pathname, preferences.locale, syncLocaleFromRoute]);

  return null;
}
